import React from "react";
/** Styles Import */
import "./Styles/reset.css";
import "./Styles/Resources/css/base.css";
import "./Styles/Resources/css/content.css";
/** Services Import */
import IndexedDb from "./Services/IndexedDb/IndexedDb";
/** Components Import */
import Routers from "./Routers/Router";
import Commons from "./Services/Common/Common";
function App() {
  IndexedDb.CreateIndexedDB();
  // 로컬 스토리지 권한 관리
  if (!Commons.Storages("get", "authorization")) {
    Commons.Storages("set", "authorization", {
      authorization: false,
      authDate: Commons.DateFormating(new Date()),
    });
  }
  return (
    <div className="App">
      <Routers />
    </div>
  );
}

export default App;
